import { Spin } from 'antd';
import classNames from 'classnames';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate } from '../../../services';

const LearningItemActionButton = ( { classBase, dataAccessor, isLoading } ) => {

    const [ loadingAction, setLoadingAction ] = useState( false );

    return ( isLoading ? <></> :
        <span
            className={ classNames( `${ classBase }-action`, { 'loading': isLoading || loadingAction }, '_title', 'learning-action', { locked: dataAccessor?.prerequisiteData?.locked, blockClick: dataAccessor?.blockClick } ) }
            onClick={ () => {
                if ( dataAccessor.blockClick ) {
                    return;
                }
                setLoadingAction( true ); 
                dataAccessor.onClick( () => { setLoadingAction( false ); } );
            } }
            >
            { loadingAction ? <Spin /> : 
                ( dataAccessor?.prerequisiteData?.locked ) ? <Translate.Text value='learningObject.actions.locked'/> :
                <Translate.Text value={ dataAccessor?.actionText }/> }
        </span>
    );
};

LearningItemActionButton.propTypes = {
    classBase: PropTypes.string.isRequired,
    dataAccessor: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
};

LearningItemActionButton.defaultProps = {
    isLoading: false,
};

export default LearningItemActionButton;